<div class="category-popup">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{data?.businessName}}<i class="fa fa-spinner fa-spin" *ngIf="isLoader"></i></h4>
    <div class="d-flex justify-content-end ms-auto">
      <button class="btn btn-secondary col-auto btn-sm me-2" (click)="closePopup();"><i class="fa fa-times"></i> Cancel</button>
      <button (click)="submitForm(form.value)" class="btn col-auto btn-primary btn-sm"
              [disabled]="form.invalid || isLoader">
        <!--<i class="fas fa-spinner fa-spin colorWhite" *ngIf="isLoader"></i>-->
        <i class="fa fa-save"></i> Save
      </button>
    </div>
  </div>
  
  <div class="modal-body">
    <form [formGroup]="form">
      <div class="row">
        <div class="col-4">
          <div class="form-group mb-2">
            <label for="name">Name</label>
            <input type="text" class="form-control" [ngClass]="{
                        'form-required-border':
                          form.get('name').invalid &&
                          (form.get('name').dirty ||
                            form.get('name').touched)
                      }" id="name" formControlName="name">

          </div>
        </div>
        <div class="col-auto">
          <div class="form-group mb-2">
            <label for="name">Short Name</label>
            <input type="text" class="form-control" [ngClass]="{
           'form-required-border':
             form.get('shortName').invalid &&
             (form.get('shortName').dirty ||
               form.get('shortName').touched)
         }" id="shortName" formControlName="shortName">

          </div>
        </div>
        <div class="col">
          <div class="form-group mb-2">
            <label for="mediaGroupId">Media Group</label>
            <select class="form-select" id="mediaGroupId" [ngClass]="{
                        'form-required-border':
                          (form.get('mediaGroupId').invalid) &&
                          (form.get('mediaGroupId').dirty ||
                            form.get('mediaGroupId').touched)
                      }" formControlName="mediaGroupId">
              <option [value]="0">Select Media Group</option>
              <option *ngFor="let group of mediaGroups" [value]="group.id">{{ group.name }}</option>
            </select>

          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group mb-2">
            <label for="leftOrRight">Left/Right</label>
            <select class="form-select" id="leftOrRight" [ngClass]="{
                        'form-required-border':
                          form.get('leftOrRight').invalid &&
                          (form.get('leftOrRight').dirty ||
                            form.get('leftOrRight').touched)
                      }" formControlName="leftOrRight">
              <option value="Left">Left</option>
              <option value="Right">Right</option>
            </select>

          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group mb-2">
            <label for="leftOrRight">Fore/Hind</label>
            <select class="form-select" id="foreOrHind" formControlName="foreOrHind">
              <option value="">Select</option>
              <option value="Fore">Fore</option>
              <option value="Hind">Hind</option>
            </select>

          </div>
        </div>
      </div>
    

    
    </form>
  </div>
</div>
